import { styled } from "@mui/material";
import { COLORS } from "assets";

const StyledInputElement = styled("input")(({ theme }) => {
  const isLight = theme.palette.mode === "light";
  return {
    ":-webkit-autofill": {
      backgroundClip: "text",
      WebkitTextFillColor: isLight ? COLORS.surface.primaryText : theme.palette.text.secondary
    },
    "::placeholder": {
      color: isLight ? COLORS.surface.mutedText : theme.palette.grey[50],
      fontWeight: 400
    },
    fontSize: "0.875rem",
    fontFamily: "inherit",
    fontWeight: isLight ? 500 : 600,
    flexGrow: 1,
    color: isLight ? COLORS.surface.primaryText : theme.palette.text.secondary,
    background: "transparent",
    border: "none",
    borderRadius: "inherit",
    outline: 0,
    paddingTop: isLight ? "8px" : "20px",
    paddingBottom: isLight ? "8px" : "20px",
    paddingLeft: isLight ? "4px" : "10px",
    paddingRight: "10px"
  };
});
export default StyledInputElement;
